// @ts-nocheck
import PropTypes from "prop-types";
import {useState} from "react";
import {useTranslation} from "react-i18next";

const gameGridCls = "grid grid-cols-2 gap-4 p-0 max-[480px]:gap-3 max-[320px]:grid-cols-1 max-[320px]:gap-2.5";
const gameCardCls =
  "group bg-[var(--color-surface-pressed)] border border-[var(--color-border)] rounded-xl overflow-hidden cursor-pointer transition-all duration-300 relative motion-safe:animate-slide-in-up opacity-0 hover:-translate-y-0.5 hover:border-[var(--color-lottery)] hover:shadow-[0_8px_25px_rgba(255,3,96,0.2)]";
const gameImageContainerCls =
  "relative w-full h-20 overflow-hidden rounded-t-xl max-[480px]:h-[var(--size-17-5)] max-[320px]:h-[var(--size-25)]";
const gameImageCls = "w-full h-full object-cover transition-transform duration-300 group-hover:scale-105";
const placeholderIconCls =
  "w-full h-full flex items-center justify-center bg-[linear-gradient(135deg,var(--color-surface-2)_0%,var(--color-surface)_100%)] text-2xl";
const gameOverlayCls =
  "absolute inset-0 bg-black/70 flex items-center justify-center opacity-0 transition-opacity duration-300 rounded-t-xl";
const gameOverlayVisibleCls = "!opacity-100";
const playButtonCls =
  "text-white text-xs font-semibold bg-[var(--color-lottery)] py-1.5 px-3 rounded-full border border-[var(--color-lottery)] flex items-center gap-1 max-[480px]:text-[var(--font-caption)] max-[480px]:py-[var(--space-1-5)] max-[480px]:px-2.5";
const rankBadgeCls =
  "absolute top-1.5 left-1.5 bg-[var(--color-lottery)] text-white text-[var(--font-eyebrow)] font-bold py-[3px] px-1.5 rounded-xl border border-white/30 shadow-[0_2px_8px_rgba(0,0,0,0.3)] z-[2] max-[480px]:text-[var(--font-eyebrow)] max-[480px]:py-[var(--space-0-5)] max-[480px]:px-[var(--space-1-5)] max-[480px]:top-1 max-[480px]:left-1";
const gameInfoCls = "p-2.5 px-3 max-[480px]:p-2 max-[480px]:px-2.5";
const gameNameCls =
  "text-xs font-semibold text-[var(--color-text)] m-0 mb-1 leading-[1.3] line-clamp-2 overflow-hidden text-ellipsis max-[480px]:text-[var(--font-caption)]";
const gameProviderCls =
  "text-[var(--font-eyebrow)] text-[var(--color-text-secondary)] m-0 capitalize font-medium max-[480px]:text-[var(--font-eyebrow)]";
const noGamesContainerCls = "py-10 px-5 text-center";
const noGamesTextCls = "text-[var(--color-text-secondary)] text-sm m-0 leading-[1.5]";

const GameGridModal = ({games, onGameSelect}) => {
  const {t} = useTranslation();
  const [hoveredGame, setHoveredGame] = useState(null);

  const handleGameClick = game => {
    // Pass the selected game to onGameSelect for parallel gaming
    onGameSelect(game);
  };

  const handleGameMouseEnter = gameId => {
    setHoveredGame(gameId);
  };

  const handleGameMouseLeave = () => {
    setHoveredGame(null);
  };

  if (!games || games.length === 0) {
    return (
      <div className={noGamesContainerCls}>
        <p className={noGamesTextCls}>{t("noQuickGamesAvailable", "No games available at the moment")}</p>
      </div>
    );
  }

  return (
    <div className={gameGridCls}>
      {games.map((game, index) => (
        <div
          key={game.id || index}
          className={gameCardCls}
          onClick={() => handleGameClick(game)}
          onMouseEnter={() => handleGameMouseEnter(game.id)}
          onMouseLeave={handleGameMouseLeave}
        >
          <div className={gameImageContainerCls}>
            {game.icon ? (
              <img
                src={game.icon}
                alt={game.name || game.game_name}
                className={gameImageCls}
                loading="lazy"
              />
            ) : (
              <div className={placeholderIconCls}>
                <span>🎮</span>
              </div>
            )}

            {/* Hover overlay */}
            <div className={`${gameOverlayCls} ${hoveredGame === game.id ? gameOverlayVisibleCls : ""}`}>
              <span className={playButtonCls}>▶ {t("playNow", "Play Now")}</span>
            </div>

            {/* Game rank badge */}
            <div className={rankBadgeCls}>#{index + 1}</div>
          </div>

          <div className={gameInfoCls}>
            <h4 className={gameNameCls}>{game.name || game.game_name || t("unknownGame", "Unknown Game")}</h4>
            <p className={gameProviderCls}>{game.provider || t("unknownProvider", "Unknown")}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

GameGridModal.propTypes = {
  games: PropTypes.arrayOf(PropTypes.object).isRequired,
  onGameSelect: PropTypes.func.isRequired,
};

export default GameGridModal;
